import { AppUtil } from 'kuaidong-lib'

export class DrillReportTipOffService {
  public static async canTipOff() {
    return (await AppUtil.isUnderApp()) && (await AppUtil.getUserData()).phone
  }

  public static async tipOff(reportId: string, reason: string): Promise<boolean> {
    return AppUtil.httpPOST(
      `${process.env.VUE_APP_CRAZYROPE_API}/user/drill_record/tip_off`,
      {
        record_id: reportId,
        tip_off_reason: reason,
      },
      {},
      false,
      false
    )
  }
}
